module.exports = "<ul id=\"u-menu\">\n  <li *ngFor=\"let p of pageList\" style=\"margin: 2px 1px;\">\n    <a href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\">\n      <span style=\"display:block;font-size:13px;\">{{p.KHB_Page}}</span>\n    </a>\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/ultilities-menu/ultilities-menu.component.html
// module id = ./src/app/ultilities/ultilities-menu/ultilities-menu.component.html
// module chunks = main